import React, {useRef} from 'react'
import styled from '@emotion/styled'
import {OnDestinationChangeParams, RecentSearchParams} from 'hooks/searchBox'

import {DestinationPicker} from './DestinationPicker'
import {DestinationPickerPortal} from './DestinationPickerPortal'
import {SuggestionsList} from './SuggestionsList'

export interface Props {
  displayValue: string
  errorMessage?: string
  hasError?: boolean
  isOpen: boolean
  onClose: () => void
  onChange: (params: OnDestinationChangeParams) => void
  onRecentSearchSelected: (params: RecentSearchParams) => void
  onSuggestionsRequested: (
    value: string,
    shouldLoadUserSearchHistory: boolean
  ) => void
  onSuggestionSelected: () => void
  onNearbyPropertiesSuggestionSelected: () => void
  destinationInputRef?: React.MutableRefObject<HTMLInputElement>
}

const DestinationPickerWrapper = styled.div`
  width: 100%;
`

const FakeDestinationInput = styled.input`
  opacity: 0;
  height: 0;
  position: absolute;
  top: 0;
`

export const DestinationPickerOverlay = ({
  displayValue,
  errorMessage,
  hasError,
  isOpen,
  onClose,
  onChange,
  onRecentSearchSelected,
  onSuggestionsRequested,
  onSuggestionSelected,
  onNearbyPropertiesSuggestionSelected,
  destinationInputRef
}: Props) => {
  const headerRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <FakeDestinationInput
        ref={destinationInputRef}
        type="text"
        id="fakeDestinationInput"
        name="fakeDestinationInput"
        value={undefined}
      />
      <DestinationPickerPortal
        isOpen={isOpen}
        onClose={onClose}
        header={
          <DestinationPickerWrapper ref={headerRef}>
            <DestinationPicker
              focusOnMount={isOpen}
              displayValue={displayValue}
              hasError={hasError}
              errorMessage={errorMessage}
              onSuggestionsRequested={onSuggestionsRequested}
            />
          </DestinationPickerWrapper>
        }
      >
        <SuggestionsList
          onChange={onChange}
          onSuggestionSelected={onSuggestionSelected}
          onRecentSearchSelected={onRecentSearchSelected}
          onNearbyPropertiesSuggestionSelected={
            onNearbyPropertiesSuggestionSelected
          }
        />
      </DestinationPickerPortal>
    </>
  )
}
